import { useState, useEffect } from 'react';

interface PreloadedImages {
  [key: string]: string;
}

export function useImagePreloader(imageUrls: string[]): {
  imagesPreloaded: boolean;
  preloadedImages: PreloadedImages;
} {
  const [imagesPreloaded, setImagesPreloaded] = useState<boolean>(false);
  const [preloadedImages, setPreloadedImages] = useState<PreloadedImages>({});

  useEffect(() => {
    let isMounted = true;
    const preloadImages = async () => {
      const promises = imageUrls.map((src) => {
        return new Promise<[string, string]>((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = () => resolve([src, src]);
          img.onerror = reject;
        });
      });

      try {
        const results = await Promise.all(promises);
        if (isMounted) {
          const mappedResults = results.reduce((acc, [key, value]) => {
            acc[key] = value;
            return acc;
          }, {} as PreloadedImages);
          
          setPreloadedImages(mappedResults);
          setImagesPreloaded(true);
        }
      } catch (error) {
        console.error('Error preloading images:', error);
      }
    };

    preloadImages();
    return () => { isMounted = false; };
  }, [imageUrls]);

  return { imagesPreloaded, preloadedImages };
}